import React from "react";
import { Link, useLocation } from "react-router-dom";
import user from "../../../assets/images/icons/User.png";
import collab from "../../../assets/images/icons/collab.png";
import mag from "../../../assets/images/icons/mag.png";
import project from "../../../assets/images/icons/project.png";
import scam from "../../../assets/images/icons/scam.png";
import submission from "../../../assets/images/icons/submission.png";
import tag from "../../../assets/images/icons/tag.png";
import upgrade from "../../../assets/images/icons/upgrade.png";
import logo from "../../../assets/images/logo.png";
import Footer from "../../_app/Footer";

export default function DashboardLayout({ children }) {
  const location = useLocation(); // Get current route location

  const role = localStorage.getItem("role");
  const occupation = localStorage.getItem("occupation");

  const userMenus = [
    {
      title: "Profile",
      icon: user,
      href: "/user-profile",
    },
    ...(occupation === "Professional" ||
      occupation === "Student" ||
      occupation === "Professor" ||
      occupation === "Company"
      ? [
        {
          title: "Projects",
          icon: project,
          href: "/user-projects",
        },
        {
          title: "Collaborators",
          icon: collab,
          href: "/user-collaborators",
        },
      ]
      : []),
    ...(occupation === "Product"
      ? [
        {
          title: "Product",
          icon: project,
          href: "/user-products",
        },
      ]
      : []),

    {
      title: "Upgrade Membership",
      icon: upgrade,
      href: "/user-membership",
    },
  ];

  const adminMenus = [
    {
      title: "Users",
      icon: user,
      href: "/all-users",
    },
    {
      title: "Projects",
      icon: project,
      href: "/all-projects",
    },
    {
      title: "Products",
      icon: project,
      href: "/all-products",
    },
    {
      title: "Tags",
      icon: tag,
      href: "/tags",
    },
    {
      title: "Submissions",
      icon: submission,
      href: "/all-submissions",
    },
    {
      title: "Scam Reports",
      icon: scam,
      href: "/scam-report",
    },
    {
      title: "Magazines",
      icon: mag,
      href:'/magzine'
    },
    {
      title: "Discounts",
      icon: tag,
      href: "/admin-discounts",
    },
    {
      title: "Analytics",
      icon: upgrade,
      href: "/admin-analytics",
    },
  ];

  const menusToShow = role === "SUPER_ADMIN" ? [...adminMenus] : userMenus;

  return (
    <>
      <div className="min-h-screen flex flex-col md:flex-row">
        <aside className="w-full md:w-64 bg-white border-r border-gray-200 flex-shrink-0">
          <div className="py-6 px-4 md:px-6">
            <Link to="/">
              <img className="w-32 mx-auto mb-6" src={logo} alt="Logo" />
            </Link>
            <div className="space-y-4">
              {menusToShow.map((menu, index) => (
                <Link
                  key={index}
                  to={menu.href}
                  className={`block py-2 px-4 rounded ${
                    location.pathname === menu.href ? 'bg-blue-400' : 'hover:bg-blue-400'
                  }`}
                >
                  <div className="flex items-center gap-4">
                    <img src={menu.icon} alt={menu.title} />
                    {menu.title}
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </aside>
        <div className="flex-1 bg-gray-200">
          <main className="py-6 sm:px-6 lg:px-8 flex-grow">
            <div className="mx-auto max-w-7xl">
              {children}
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
}
